import React, { useEffect, useRef, useState } from 'react'
import { styled } from '@mui/material';
import { Button, Input, Col, DatePicker, Divider, Flex, Modal, Row, Select, Table, Tag, Tooltip, Typography, Image, Alert, Checkbox } from 'antd';
import dayjs from 'dayjs';
import AuthService from '../../Components/auth/AuthService';
import { hideLoading, showLoading, useLoadingDispatch } from '../../context/loadingContext';
import { locationTypes, vehicleTypes } from '../../Components/common/Constants';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined, DeleteFilled, ExportOutlined, InfoCircleOutlined, InfoCircleTwoTone, LockFilled, NumberOutlined, SnippetsOutlined, UnlockFilled } from '@ant-design/icons';
import ScanInput from '../Scan/ScanInput';
import ScanSelect from '../Scan/ScanSelect';
import { useSelector } from 'react-redux';
import { showMessage } from '../../Components/Utils/message';
import ProductScanSelect from '../Scan/ProductScanSelect';
import ProductInfoModal from '../../Components/Modals/ProductInfoModal';
import LockPickingButton from '../../Components/common/LockPickingButton';
import DetailsGrid from '../../Components/common/DetailsGrid';
import InputBox from '../../Components/common/InputBox';
import { env, netsuite_url, wms_uploads_cdn } from '../../Components/config';
import ReturnDrawer from '../../Components/Drawers/ReturnDrawer';
const Auth = new AuthService();
const DataSheet = styled('div')`
    .ant-select .ant-select-selector {
      border-bottom: 1px solidrgb(203, 195, 195);
      border-top: 0px !important;
      border-left: 0px;
      border-right: 0px;
      border-radius: 0px
    }
    .ant-input-disabled {
      background: none;
      color: black;
      fontWeight: 500;
    }
`;

const RouteReturns = () => {
  const { Option } = Select;
  const { Text, Title } = Typography;
  const { locations, products } = useSelector((state) => state?.AppState?.userCreds);

  const navigate = useNavigate();
  const layoutDispatch = useLoadingDispatch()
  const [deliveryDate, setDeliveryDate] = useState(dayjs());
  const [routes, setRoutes] = useState([]);

  const [allRouteData, setAllRouteData] = useState([]);
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const handleOpenDrawer = (row) => {
    if (row) {
      setSelectedRoute(row);
    }
    setDrawerOpen(true);
  };
  const handleCloseDrawer = () => {
    setDrawerOpen(false)
    setSelectedRoute(null);
    loadRoutes();
  };


  const dataCol = [
    {
      title: 'Action',
      key: 'details',
      align: "left",
      dataIndex: '',
      // width: 100,
      render(record) {
        const completed = record?.start_status === 2 ? true : false;
        return (
          <div onClick={(e) => e.stopPropagation()}>
            {/* <Tooltip title="View reports"> */}
            <Button
              type="primary"
              style={{ cursor: "pointer" }}
              onClick={() => {
                if(!completed) return showMessage('error', "Route not completed ")
                handleOpenDrawer(record);
              }}
            >Select</Button>
            {/* </Tooltip> */}
          </div>
        );
      },
    },
    {
      title: "Route",
      // width: 140,
      render(record) {
        return (
          <span>{`${record.title} (${record.code})`}</span>
        );
      },
    },
    {
      title: "Vehicle",
      dataIndex: "registration_number",
      key: "registration_number",
      // width: 80,
    },
    {
      title: "Driver Name",
      dataIndex: "driver_name",
      key: "driver_name",
      // width: 180,
    },
    {
      title: 'Status',
      align: 'center',
      render(record) {
        const completed = record?.start_status === 2 ? true : false;
        const goods_return = record?.route_returned_by > 0 ? true : false;
        const return_posted = record?.route_returned_posted_by > 0 ? true : false;
        const picked = record?.route_picked_by > 0 ? true : false;
        const packed = record?.route_packed_by > 0 ? true : false;

        return (
          <Flex gap={5}>
            <Tag color={picked ? 'green' : 'volcano'} >Route Picked</Tag>
            <Tag color={packed ? 'green' : 'volcano'} >Route Packed</Tag>
            <Tag color={completed ? 'green' : 'volcano'} >Route Completed</Tag>
            <Tag color={goods_return ? 'green' : 'volcano'}>Route Returned</Tag>
            <Tag color={return_posted ? 'green' : 'volcano'} >Stock Discrepancies</Tag>

          </Flex>
        );
      },
      // width: 200
    },
  ];

  const loadRoutes = async () => {
    showLoading(layoutDispatch)
    try {
      const routeRes = await Auth.post(`/route/load-locked-routes`, {
        delivery_date: dayjs(deliveryDate).format("YYYY-MM-DD"),
      })
      if (routeRes.ack) setRoutes(routeRes.routes);
      else showMessage('error', routeRes.message);
    } catch (err) {
      showMessage('error', 'something went wrong')
    } finally {
      hideLoading(layoutDispatch)
    }
  };


  const getRouteData = async (routeID) => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/route/load-route-returns?route_status_id=${routeID}`);
      if (res?.ack) {
        console.log(res);
        setAllRouteData(res?.daily_returns || []);

      } else {
        setAllRouteData([])
        showMessage('error', res?.message);
      }
    } catch (err) {
      console.log(err);
      showMessage('error', 'something went wrong')
    } finally {
      hideLoading(layoutDispatch)
    }
  };

  return (
    <DataSheet>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center', marginBottom: '10px' }}>
        <h3 style={{ margin: 0 }}>Route Returns</h3>
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate("/stocks")}>Back</Button>
      </div>

      <Flex justify="space-between" align="center" gap={10} style={{ marginBottom: '16px' }} wrap>
        <Flex gap="small" flex={1} style={{ maxWidth: '300px' }}>
          <DatePicker
            format="DD-MM-YYYY"
            value={deliveryDate}
            onChange={(date) => setDeliveryDate(date ? dayjs(date, 'YYYY-MM-DD') : null)}
            placeholder="Select Date"
            style={{ flex: 1 }}
          />
          <Button type="primary" onClick={loadRoutes}>
            Load Routes
          </Button>
        </Flex>
      </Flex>
    {
      routes?.length > 0 && (
         <Table
                style={{  marginTop: "10px" }}
                scroll={{ x: 'max-content'}}
                columns={dataCol}
                dataSource={routes?.sort((a, b) => a.title.localeCompare(b.title))}
                pagination={false}
              />
      )
    }
     
        <ReturnDrawer deliveryDate={deliveryDate} drawerOpen={drawerOpen} selectedRoute={selectedRoute} handleCloseDrawer={handleCloseDrawer} />

    </DataSheet>

  )
}

export default RouteReturns